import { Notes } from "@mui/icons-material";
import { Paper, Stack, Typography } from "@mui/material";
import { alpha } from "@mui/material/styles";

interface PatientNoteSectionProps {
  /** Texto único da nota, com \n reais para quebra de linha. */
  noteText: string;
}

/**
 * Nota escrita pelo paciente, sempre como última seção da página.
 * Um único título: as quebras de linha do texto não criam novas seções.
 */
export function PatientNoteSection({ noteText }: PatientNoteSectionProps) {
  return (
    <Paper
      elevation={0}
      sx={{
        width: "100%",
        maxWidth: "100%",
        minWidth: 0,
        borderRadius: 3,
        border: "1px solid",
        borderColor: "neutral300.main",
        overflow: "hidden",
      }}
    >
      <Stack
        direction="row"
        spacing={1.5}
        alignItems="center"
        sx={{
          px: { xs: 1.5, sm: 2.5 },
          py: 1.5,
          minWidth: 0,
          bgcolor: (t) => alpha(t.palette.primary.main, 0.06),
          borderBottom: "1px solid",
          borderColor: "neutral300.main",
        }}
      >
        <Notes sx={{ fontSize: 24, color: "primary800.main" }} aria-hidden />
        <Typography
          sx={{
            fontSize: "1.0625rem",
            fontWeight: 700,
            minWidth: 0,
            overflowWrap: "anywhere",
          }}
        >
          Nota do paciente
        </Typography>
      </Stack>

      <Typography
        sx={{
          px: { xs: 1.5, sm: 2.5 },
          py: 2,
          minWidth: 0,
          fontSize: "1rem",
          lineHeight: 1.6,
          // Preserva as quebras de linha escritas pelo paciente
          whiteSpace: "pre-line",
          overflowWrap: "anywhere",
        }}
      >
        {noteText}
      </Typography>
    </Paper>
  );
}
